import { ref, readonly } from 'vue';

export interface CameraModalState {
  cameraId: string | number;
  cameraName: string;
  hasPtz: boolean;
  hasAudio: boolean;
}

const isOpen = ref(false);
const current = ref<CameraModalState | null>(null);

export function useCameraModal() {
  function open(state: CameraModalState) {
    current.value = state;
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
    // Delay clearing to allow close animation
    setTimeout(() => {
      current.value = null;
    }, 300);
  }

  return {
    isOpen: readonly(isOpen),
    current: readonly(current),
    open,
    close,
  };
}
